import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import SendPersonEmail from "./components/sendPersonEmail.vue";
import SendServiceEmail from "./components/sendServiceEmail.vue";
import ShowEmailTable from "./components/showEmailTable.vue";
import DataOptions from "../../components/timeList/dataOptions.vue";
import infoList from "../../mixins/infoList";
import { EmailList } from "@/api/data";
export default {
  name: "sendMailRequest",
  components: {
    SendPersonEmail: SendPersonEmail,
    ShowEmailTable: ShowEmailTable,
    SendServiceEmail: SendServiceEmail,
    DataOptions: DataOptions
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: EmailList,
      tableInfo: [],
      options: [{
        id: 0,
        label: "全部"
      }, {
        id: 1,
        label: "待审核"
      }, {
        id: 2,
        label: "审核失败"
      }, {
        id: 3,
        label: "审核通过"
      }, {
        id: 4,
        label: "发送成功"
      }, {
        id: 5,
        label: "发送失败"
      }],
      email_state: 1,
      formTime: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      searchInfo: {
        email_state: "",
        sdate: this.$moment().subtract(7, "days").format("YYYY-MM-DD"),
        edate: this.$moment().format("YYYY-MM-DD")
      },
      //点击发送个人邮件,弹出框
      personalDialog: false,
      //点击发送单服邮件,弹出框
      serverDialog: false,
      //单服邮件信息包含
      formInfoSer: {
        server_id_list: [],
        // 服务器列表
        email_type: 2,
        expire: "",
        //邮件发送截至时间
        item_list: [{
          item_id: "",
          num: 1
        }],
        condition: [{
          login_time_range: {
            sdate: "",
            edate: ""
          },
          create_time_range: {
            sdate: "",
            edate: ""
          },
          pay_amount_range: {
            min: "",
            max: ""
          },
          role_level_range: {
            min: "",
            max: ""
          }
        }],
        email_title: "",
        email_content: "",
        is_timing_send: 0,
        //是否定时发送
        timing_send: "" //定时发送日期与时间
      },

      //个人邮件
      formInfoPer: {
        email_id: 0,
        email_type: 1,
        expire: "",
        //已读邮件后保留时间
        server_id: "",
        // 服务器列表
        role_type: "",
        //1:角色id,2:角色名
        role_list: [],
        // emailMould: "", //邮件模板
        email_title: "",
        email_content: "",
        item_list: [{
          item_id: "",
          num: 1
        }],
        is_timing_send: 0,
        //是否定时发送 (0：否 ，1：是)
        timing_send: "" //定时发送日期与时间
      }
    };
  },
  created: function created() {
    this.queryEvent();
  },
  methods: {
    queryEvent: function queryEvent() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this.searchInfo.sdate = _this.formTime[0];
              _this.searchInfo.edate = _this.formTime[1];
              _this.searchInfo.email_state = _this.email_state;
              _context.next = 5;
              return _this.getTableData();
            case 5:
              _this.tableInfo = _this.tableData;
              if (!_this.tableInfo) {
                _this.$message({
                  message: "暂无数据"
                });
              } else if (_this.tableInfo && _this.tableInfo.length === 0) {
                _this.$message({
                  message: "暂无数据"
                });
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    //打开邮件
    sendSomeEmail: function sendSomeEmail(e) {
      var _this2 = this;
      //1：发送个人邮件
      if (e === 1) {
        var editAllInfo = {
          isEditPage: false,
          formInfo: this.formInfoPer
        };
        this.personalDialog = true;
        this.$nextTick(function () {
          _this2.$refs.perChild.init(editAllInfo);
        });
      } else {
        //2是发送单服邮件
        var _editAllInfo = {
          isEditPage: false,
          formInfo: this.formInfoSer
        };
        this.serverDialog = true;
        this.$nextTick(function () {
          _this2.$refs.serChild.init(_editAllInfo);
        });
      }
    },
    //点击表格编辑返回的数据
    sendData: function sendData(e) {
      var _this3 = this;
      //isEditPage === true代表编辑
      //openEmailType === 2代表单服，1代表个人
      //点击当前行的信息 === formInfo
      var editAllInfo = {
        isEditPage: true,
        formInfo: e.formInfo
      };
      if (e.openEmailType === 1) {
        this.personalDialog = true;
        this.$nextTick(function () {
          _this3.$refs.perChild.init(editAllInfo);
        });
      } else {
        //2是发送单服邮件
        this.serverDialog = true;
        this.$nextTick(function () {
          _this3.$refs.serChild.init(editAllInfo);
        });
      }
    },
    //个人邮件的返回关闭弹出框
    backPersonEmail: function backPersonEmail(e) {
      this.queryEvent();
      this.personalDialog = e.dialogFormVisible;
    },
    //单服邮件的返回关闭弹窗
    backServerEmail: function backServerEmail(e) {
      this.queryEvent();
      this.serverDialog = e.dialogFormVisible;
    },
    //弹出页面需求
    openPop: function openPop() {
      this.$notify({
        title: "邮件申请",
        message: "(1)有权限的运营人员可以发起邮件申请。" + "(2)需要对接研发发送邮件接口，研发接口需要提供满足下面条件的邮件发送功能。" + "（3）邮件类型可选：1个人邮件，2单服邮件" + "1个人邮件：如果选发送个人邮件，可输入需要发送的玩家Id+服务器Id列表 或者 玩家昵称+服务器Id列表，玩家列表输入框一行表示一个玩家" + "2单服邮件：如果选发送单服邮件，可选全服发送或者需要发送的服务器列表，另外可选发送条件（包含 角色登录时间段，角色等级，创角时间，充值金额 " + "  等一个或多个条件），有选发送条件的，只有符合条件的玩家才会收到邮件" + "（4）邮件正文内容" + "(5)邮件可以添加附件，附件包含充值货币和其他货币以及游戏道具，可多选游戏道具配置，包含道具Id和发送数量" + "(6)邮件状态包含：待审批，审批通过，审批驳回" + "(7)邮件需要记录申请人的Id，邮件申请时间、审批人Id，审批时间，审批原因，发送时间，调用发送接口研发返回的状态",
        duration: 0
      });
    }
  }
};